import styles from './styles.module.scss';

import amexIcon from "../../../assets/images/payment-method-logo/amex.svg";
import dinersIcon from "../../../assets/images/payment-method-logo/diners.svg";
import discoverIcon from "../../../assets/images/payment-method-logo/discover.svg";
import jcbIcon from "../../../assets/images/payment-method-logo/jcb.svg";
import mastercardIcon from "../../../assets/images/payment-method-logo/mastercard.svg";
import unionpayIcon from "../../../assets/images/payment-method-logo/unionpay.svg";
import visaIcon from "../../../assets/images/payment-method-logo/visa.svg";
import bancontactIcon from "../../../assets/images/payment-method-logo/bancontact.svg";
import epsIcon from "../../../assets/images/payment-method-logo/eps.svg";

const PaymentIcons = () => {
  return (
    <ul className={styles.paymentIcons}>
      <li>
        <img src={amexIcon} alt="Amex" />
      </li>
      <li>
        <img src={dinersIcon} alt="Diners" />
      </li>
      <li>
        <img src={discoverIcon} alt="Discover" />
      </li>
      <li>
        <img src={jcbIcon} alt="JCB" />
      </li>
      <li>
        <img src={mastercardIcon} alt="Mastercard" />
      </li>
      <li>
        <img src={unionpayIcon} alt="Unionpay" />
      </li>
      <li>
        <img src={visaIcon} alt="Visa" />
      </li>
      <li>
        <img src={bancontactIcon} alt="Bancontact" />
      </li>
      <li>
        <img src={epsIcon} alt="Eps" />
      </li>
    </ul>
  );
};

export default PaymentIcons;
